export const messages = {
  error: {
    id: "video.error",
    defaultMessage:
      "There was an error loading the video. Please try again later.",
  },
};
